import { Link } from "~/components/Link";
import { NetworkBadge } from "../NetworkBadge";
import { TokenMessages } from "../TokenMessages";
import { getNetworkURL } from "~/routes";
import { AssetUserEvents } from "~/modules/analytics/events/assets";
import { TokenRowData } from "../types";

// // // //

export function TokenNetworkLink(props: { token: TokenRowData }) {
    const { token } = props;

    if (token.network.slug === "book-entry") {
        return (
            <div className="py-0.5 px-0.5 flex items-center">
                <NetworkBadge network={token.network} isLink={false} />
                <p className="ml-2 dg-overflow">{token.network.name}</p>
            </div>
        );
    }

    return (
        <div className="py-0.5 ml-7 flex items-center">
            <Link
                href={getNetworkURL({ networkSlug: token.network.slug })}
                variant="default"
                className="flex items-center"
                analyticsLabel={AssetUserEvents.ClickTokenNetworkLink}
                analyticsEventProperties={{
                    network: token.network.slug,
                }}
            >
                <NetworkBadge network={token.network} enableTooltip={false} />
                <p className="ml-2">{token.network.name}</p>
            </Link>

            <TokenMessages token={token} ticker={token.parentAsset.ticker} />
        </div>
    );
}
